export enum HTML_ERRORS {
    ENTER_MOBILE_NO = "Please enter a mobile no.",
    FOLDERNAME_EXISTS = "A Folder with this name already exists.",
    FOLDERNAME = "Please enter a name for your folder.",
    FOLDERNAME_INVALID_CHAR = "Please enter a folder name without / \\ < > : \" | ? *",
    FOLDERNAME_INVALID_END = "Folder name cannot end with ' . '",
    NETWORK_CONNECTION_ERR = "Please check your network connection and try again later.",
    LOCK_APP_WARNING = "Any more failed attempt will lock the application for 10 minutes.",
    INVALID_CSV_FILE = "Invalid file, please upload a valid CSV.",
    DRAG_DROP_MULTIPLE_FILES_CSV = "Drag/Drop of multiple files not allowed. Kindly upload a valid CSV.",
    FILE_SIZE_100KB = "Please upload a file lesser than 100 KB",
    INVALID_EMAIL = "Please enter a valid email.",
    INVALID_OTP = 'Entered OTP is invalid/expired.',
    EMPTY_EMAIL = "Enter mobile number or valid email.",
    INVALID_MOB_NO = "Please enter a valid mobile no.",
    INVALID_STORAGE_ADD_USER = "Please enter a valid storage value.",
    PROFILE_EMPTY_NAME = "A name cannot be empty. Please enter a valid name.",
    PROFILE_EMPTY_FIRST_NAME = "First name field cannot be empty. Please enter a valid name.",
    PROFILE_EMPTY_LAST_NAME = "Last name field cannot be empty. Please enter a valid name.",
    PROFILE_INVALID_NAME = "Space, numbers and special characters are not allowed.",
    EMAIL_VERIF_MAX_LIMIT = "Maximum limit has been reached. Please try after some time.",
    TEAM_FOLDER_RENAME_MINIMUM_LENGTH = "Min. 3 chars needed, can use A-Z, a-z, 0-9, spaces, hyphens (-), brackets () & underscore (_)",
    TEAM_FOLDER_RENAME_MAXIMUM_LENGTH = "Team Folder name cannot be greater than 30 characters",
    TEAM_FOLDER_RENAME_INVALID_CHARACTERS = "Valid characters include A-Z, a-z, 0-9, spaces, hyphens (-), brackets () & underscore (_)",
    TEAM_FOLDER_RENAME_EMPTY = "Team Folder name cannot be empty",
    CONTACT_SALES_NAME_VALIDATION ="Number and Special characters are not allowed",
    CONTACT_SALES_COMPANY_NAME_VALIDATION ="Special characters are not allowed",
    CONTACT_SALES_PHONE_VALIDATION ="Please enter 10-digit phone number",
    CONTACT_SALES_EMAIL_VALIDATION ="Enter a valid email address",
    CONTACT_SALES_CAPTCHA_API_VALIDATION = "Could not load Captcha, refresh again",
    MAC_NOT_SUPPORTED_MESSAGE = "For a better experience, please switch to latest version of Chrome or Safari browser. Your browser may not work optimally with our application.",
    WINDOWS_NOT_SUPPORTED_MESSAGE = "For a better experience, please switch to latest version of Chrome or Firefox browser. Your browser may not work optimally with our application."
}